import { observer } from "mobx-react";
import styles from "./styles/NavigationSecondary.module.scss";
import classNames from "classnames";
import MegaNav from "./navigation/meganav/MegaNav";
import { useGridType } from "../../hooks/useGridType";
import { GridTypes } from "../../utils/SchoolBlocksUtilities";
import { useFloatingBlocksThemeLayout } from "../../hooks/useFloatingBlocksThemeLayout";
import { useStores } from "../../stores/useStores";
import { useTranslateClassName } from "../../hooks/useTranslateClassName";

const NavigationSecondary = observer(
  (props: {
    isWelcomePage: boolean;
    visible: boolean;
    heroIsEnabled: boolean;
  }) => {
    const { organizationStore } = useStores();
    const gridType = useGridType();
    const floatingBlocksThemeLayout = useFloatingBlocksThemeLayout();
    const translateClassName = useTranslateClassName();

    const secondaryClassName = classNames({
      [styles.secondary]: true,
      [styles.secondaryFloatingBlocks]: floatingBlocksThemeLayout,
      [styles.secondarySubOrg]:
        organizationStore.organization.id !==
          organizationStore.currentOrganization.id &&
        gridType === GridTypes.terraced &&
        props.heroIsEnabled,
      [styles.secondaryVisible]: props.visible,
      [translateClassName]: true,
      ["sb-secondary-nav sb-organization-color-secondary-nav clearfix"]:
        !props.isWelcomePage,
      ["sb-navbar-secondary-container sb-content-width-plus-margin"]:
        !props.isWelcomePage && floatingBlocksThemeLayout,
    });

    return (
      <div className={secondaryClassName} id={"sb-secondary-nav"}>
        <MegaNav />
      </div>
    );
  },
);

export default NavigationSecondary;
